import { render, staticRenderFns } from "./determinacion-delas-cuotas-obrero-patronales-menusales.vue?vue&type=template&id=5deff63a&lang=html&"
import script from "./determinacion-delas-cuotas-obrero-patronales-menusales.vue?vue&type=script&lang=js&"
export * from "./determinacion-delas-cuotas-obrero-patronales-menusales.vue?vue&type=script&lang=js&"
import style0 from "./determinacion-delas-cuotas-obrero-patronales-menusales.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports